





























































































































import { Component, Mixins, Vue, Prop } from "vue-property-decorator";
import SettingMixin from "@/mixins/settingMixin";
import { RequestResult, INCENTIVE_TYPE } from "@/apis";
import ExpansionPanels from "@/components/ExpansionPanels.vue";

import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import videojs, { VideoJsPlayerOptions } from "video.js";
// import {Player,VideoJsPlayerOptions} from "../../node_modules/@types/video.js/index.js"
import "video.js/dist/video-js.css";

@Component({
  components: {
    ContainImage,
    ImageButton,
    ExpansionPanels,
  },
})
export default class Result extends Mixins(Vue, SettingMixin) {
  @Prop()
  result!: RequestResult;

  ended = false;
  isWon = false;
  isInKind = false;
  videoSrc = "";
  topImageSrc = "";
  bottomImageSrc = "";
  incentiveUrl = "";
  wid = window.innerWidth;
  isMounted = false;

  ready = false;

  player: videojs.Player | null = null;
  options: VideoJsPlayerOptions | null = null;

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;
    if (this.result) {
      this.videoSrc = this.result.lottery_creative_url;
      this.topImageSrc = this.result.result_top_creative_url;
      this.bottomImageSrc = this.result.result_bottom_creative_url;
      this.isWon = this.result.won;
      this.incentiveUrl = this.result.incentive_url ?? "";
      this.isInKind = this.result.incentive_type === INCENTIVE_TYPE.InKind;

      localStorage.scpnres = JSON.stringify({
        topImageSrc: this.topImageSrc,
        bottomImageSrc: this.bottomImageSrc,
        isWon: this.isWon,
        incentiveUrl: this.incentiveUrl,
        isInKind: this.isInKind,
      });

      this.setVideo();
    } else {
      const result = JSON.parse(localStorage.scpnres);
      this.topImageSrc = result.topImageSrc;
      this.bottomImageSrc = result.bottomImageSrc;
      this.isWon = result.isWon;
      this.isInKind = result.isInKind === INCENTIVE_TYPE.InKind;
      this.incentiveUrl = result.incentiveUrl ?? "";
      this.ended = true;
      this.isMounted = true;
    }

    window.onresize = () => {
      this.wid = window.innerWidth;
    };
  }

  setVideo(): void {
    this.options = {
      autoplay: true,
      controls: true,
      muted: true,
      preload: "auto",
      sources: [
        {
          src: this.videoSrc,
          type: "video/mp4",
        },
      ],
    };

    this.player = videojs("vid", this.options);
    const topElement = document.getElementById("container") as Element;

    this.player.on("canplay", () => {
      this.ready = true;
      setTimeout(() => {
        this.$scrollTo(topElement, 0, {});
      }, 1);
      this.player?.play();
      this.isMounted = true;
    });

    this.player.on("ended", () => {
      this.ended = true;
    });

    this.player.on("play", () => {
      setTimeout(() => {
        this.$scrollTo(topElement, 0, {});
      }, 1);
    });

    setTimeout(() => {
      this.player?.play();
    }, 1000);
  }

  beforeDestroy(): void {
    if (this.player) {
      this.player.dispose();
    }
  }

  onClickToCampaignPage(): void {
    this.routerPushCampaignPage();
  }

  onClickToInputInfoPage(): void {
    const url = this.incentiveUrl;
    window.open(url, "_blank");
  }

  get style(): string {
    return this.configStyle; // + `height: 53%;`;
  }

  get buttonStyle(): string {
    if (this.isInKind && this.isWon) {
      return `top: ${this.wid * 1.44 - 2}px; right: 1px;`;
    }
    if (this.isInKind && !this.isWon) {
      return `top: ${this.wid * 1.67 - 34}px; right: 1px;`;
    }

    // TODO デザインまだ
    if (!this.isInKind && this.isWon) {
      return `top: ${this.wid * 1.67 - 34}px; right: 1px;`;
    }
    if (!this.isInKind && !this.isWon) {
      return `top: ${this.wid * 1.67 - 34}px; right: 1px;`;
    }
    return "";
  }

  get buttonClass(): string {
    if (this.isInKind && this.isWon) {
      return "buttons twoButton";
    }
    if (this.isInKind && !this.isWon) {
      return "buttons oneButton";
    }

    // TODO デザインまだ
    if (!this.isInKind && this.isWon) {
      return "buttons oneButton";
    }
    if (!this.isInKind && !this.isWon) {
      return "buttons oneButton";
    }
    return "";
  }
}
